import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaListTR = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmediaTR.socialmediaListTR);
    const [socialmediaListTR, setSocialmedialListTR] = useState(s);
    const loading = useSelector(state => state.socialmediaTR.loading);
    const e = useSelector(state => state.socialmediaTR.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmediaTR.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.TURKISH_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaListTR}
            setSocialmedialList={setSocialmedialListTR}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}